const selectPath = (item, selector) => {
  const parts = selector.split('.')
  return parts.reduce((acc, val) => acc && acc[val], item)
}

export default selectPath
